(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("Home", [
            'jquery/jquery-3.2.1',
            'owl-carousel/owl.carousel',
            'textTyping/textTyping'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery/jquery-3.2.1'),
            require('owl-carousel/owl.carousel'),
            require('textTyping/textTyping')
        );
    } else {
        // Browser globals (root is window)
        root.Home = factory(
            root.$,
            root.OwlCarousel,
            root.TextTyping
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($, OwlCarousel, TextTyping) {

    let Init = function () {
        TextTyping.init("typed", {
            stringsElement: "#typed-strings",
            startDelay: 500,
            typeSpeed: 120,
            backSpeed: 50,
            loop: true,
            shuffle: false,
            cursorChar: '|',
            smartBackspace: true,
            showCursor: true
        });

        // if ($(window).width() >= 768) {
        //     setTimeout(function () {
        //         Works.worksCaro();
        //     }, 300)
        // }
        //
        // Works.workLoad();

    };

    Init();

}));